import { render } from "./ClientFilter.vue?vue&type=template&id=9f57c384"
import script from "./ClientFilter.vue?vue&type=script&lang=js"
export * from "./ClientFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__